import { render, staticRenderFns } from "./ToolingAttributes.vue?vue&type=template&id=d33a4bee&scoped=true"
import script from "./ToolingAttributes.vue?vue&type=script&lang=js"
export * from "./ToolingAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33a4bee",
  null
  
)

export default component.exports